<template>
<div>
  <button @click="goBack">Go Back</button>
  <div class="container mt-4">
    <div class="cardSet">
      <!-- User Information -->
       <div class="teacher">
          <div v-if="teacher && teacher.user" class="card mb-4">
            <div class="card-header">
              <h2 class="card-title mb-0">User Information</h2>
            </div>
            <div class="card-body">
              <img :src="teacher.user.profile_photo_url" alt="Profile Photo" class="img-fluid rounded-circle" />
              <p><strong>Name:</strong> {{ teacher.user.first_name }} {{ teacher.user.last_name }}</p>
              <p><strong>Email:</strong> {{ teacher.user.email }}</p>
            </div>
    
            <div class="card-body">
              <p><strong>Teacher NIC:</strong> {{ teacher.teacher_nic }}</p>
              <p><strong>Date of Birth:</strong> {{ teacher.birth_day }}</p>
              <p><strong>Address:</strong> {{ teacher.address }}</p>
              <p><strong>Contact:</strong> {{ teacher.contact }}</p>
            </div>
          </div>
        </div>
    
        
    <!-- Items -->
     <div class="card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <h2 class="card-title mb-0">Items</h2>
        <button 
              v-if="teacher" 
              @click="openAddTeacherPackageModal(teacher.id, teacher.user_id, account.package_id)" 
              class="btn btn-outline-primary btn-sm" 
              data-bs-toggle="modal" 
              data-bs-target="#addTeacherPackageModal"
            >
              <i class="bi bi-plus"></i> Add Or Update
            </button>
      </div>
      
    <div v-if="teacher && teacher.items && teacher.items.length">
      
    
    
      <div>
            <!-- <button 
              v-if="teacher" 
              @click="openAddTeacherPackageModal(teacher.id, teacher.user_id, account.package_id)" 
              class="btn btn-outline-primary btn-sm" 
              data-bs-toggle="modal" 
              data-bs-target="#addTeacherPackageModal"
            >
              <i class="bi bi-plus"></i> Add Or Update
            </button> -->
          </div>
    
    
      <div class="card-body">
        <!-- Paginated Items Display -->
        <div v-for="(item, index) in paginatedItems" :key="item.id" class="mb-3 p-3 border rounded position-relative">
          <!-- Bin Icon -->
          <i 
            class="bi bi-trash text-danger position-absolute top-0 end-0 m-3" 
            style="cursor: pointer;" 
            @click="deleteItem(item.id, index)"
          ></i>
          
          <p><strong>Item ID:</strong> {{ item.id }}</p>
          <p><strong>Subject:</strong> {{ item.subject.name }}</p>
          <p><strong>Subject Price:</strong> {{ item.subject.subject_price }}</p>
          <p><strong>Student Level:</strong> {{ item.student_level.level }}</p>
          <p><strong>Total Item Price:</strong> {{ item.item_total_price }}</p>
        </div>
      </div>
    
      <!-- Pagination Controls -->
      <div class="card-footer text-center">
        <button 
          class="btn btn-primary me-2" 
          :disabled="currentPage === 1" 
          @click="prevPage">
          Previous
        </button>
        <button 
          class="btn btn-primary" 
          :disabled="currentPage === totalPages" 
          @click="nextPage">
          Next
        </button>
        <p class="mt-2">Page {{ currentPage }} of {{ totalPages }}</p>
      </div>
    </div>
    </div>
    
    
    
    
          <!-- Account Section with Total Price -->
    <!-- Account Section with Total Price -->
    <div v-if="teacher && teacher.user" class="card mb-4">
      <div class="card-header">
        <h2 class="card-title mb-0">Account</h2>
      </div>
    
      <div class="card-body">
        <!-- Form for submitting account details -->
        <form @submit.prevent="submitForm">
          <p><strong>User ID:</strong> {{ teacher.user.id }}</p>
          <p><strong>Teacher ID:</strong> {{ teacher.id }}</p>
          <p><strong>Total Student:</strong> {{ totalStudents }}</p>
          <p><strong>Total Subjects:</strong> {{ totalSubjects }}</p>
          <p><strong>Total Item Price:</strong> {{ totalItemPrice }}</p>  
          <p><strong>Total Package Price:</strong> {{ totalPackagePrice }}</p>
    
    
          <div v-if="account">
        <!-- Dropdown for selecting a package -->
        <div class="form-group">
          <label for="pkg" class="text-start d-block">
            <i class="bi bi-geo-alt-fill"></i>Change Package
          </label>
          <select v-model="account.package_id" id="package" class="form-control" :disabled="account.account_status_id != 1" required>
            <option value="disabled" disabled>Select Package</option>
            <option v-for="pkg in packages" :key="pkg.id" :value="pkg.id">
              {{ pkg.type }} = {{ pkg.package_price }} = {{ pkg.pkg_price_for_month }}
            </option>
          </select>
        </div>
    
    
        <!-- Display selected package price -->
    <div v-if="selectedPackage">
      <p>Selected Package Price: {{ selectedPackage.package_price }}</p>
      <p>Price per Month: {{ selectedPackage.pkg_price_for_month }}</p>
      <p>Duration: {{ selectedPackage.duration }} Month</p>
    </div>
    
          </div>
    
    
    
    
    
          <!-- <p><strong>User ID:</strong> {{ teacher.user.id }}</p> -->
    
          <!-- Start Date Input Field -->
    
          <div v-if="account">
    
            <div v-if="selectedPackage">
    
            <!-- {{selectedPackage.duration}} -->
          </div>
          <div class="mb-3">
            <label for="startDate" class="form-label"><strong>Start Date:</strong></label>
            <input type="date" id="startDate" v-model="start_date" class="form-control" :disabled="account.status != 1"/>
          </div>
    
          <!-- End Date Input Field -->
          <div class="mb-3">
            <label for="endDate" class="form-label"><strong>End Date:</strong></label>
            <input type="date" id="endDate" v-model="end_date" class="form-control" disabled/>
          </div>
        </div>
    
          <!-- Success Message -->
          <div v-if="successMessage" class="alert alert-success">
            <i class="bi bi-check-circle-fill"></i> {{ message }}
          </div>
      
          <!-- Error Message -->
          <div v-if="errorMessage" class="alert alert-danger">
            <i class="bi bi-exclamation-circle-fill"></i> {{ errorMessage }}
          </div>
    
          <!-- <button 
        type="submit" 
        class="btn btn-primary" 
        >
        Activate Account
      </button> -->
      <!-- <div v-if="account">
        <p><strong>Status:</strong> {{ accountStatusMessage }}</p>
      </div> -->

      <div v-if="account">
        <p><strong>Status:</strong> {{ account.account_status.status_name }}</p>
      </div>
      
    
    
          <div v-if="account">
            <p><strong>Status:</strong> {{ account.account_status_id }}</p>
          <!-- Submit Button -->
          <button 
        type="submit" 
        class="btn btn-primary" 
        :disabled="account.account_status_id != 1">
        Activate Account
      </button>

      
        </div>
    
            <!-- Show this section if there is no account data -->
            <div v-else>
          <button 
            type="submit" 
            class="btn btn-primary">
            Create Account
          </button>
        </div>
    
    
        </form>
      </div>
    </div>
    
    
          <!-- Show Activated Account -->
          <div class="card mb-4">
            <div class="card-header">
              <h2 class="card-title mb-0">Activated Account</h2>
            </div>
    
        <div class="card-body">
          <div v-if="account">
            <p><strong>User ID:</strong> {{account.user_id }}</p>
            <p><strong>Teacher ID:</strong> {{ account.teacher_id }}</p>
            <p><strong>Package ID:</strong> {{account.package_id }}</p>
            <p><strong>Start Date:</strong> {{ account.start_date }}</p>
            <p><strong>End Date:</strong> {{ account.end_date }}</p>
            <p><strong>Status:</strong> {{ account.account_status.status_name }}</p>
            <p><strong>Package Total Price:</strong> {{ account.pkg_total_price }}</p>
            <p><strong>Total Students Level:</strong> {{ account.total_students_level }}</p>
            <p><strong>Total Subjects:</strong> {{ account.total_subjects }}</p>
          </div>
          <div v-else>
            <p>No account information available.</p>
          </div>
        </div>
          </div>
    
          <!-- Modal View -->
          <div class="modal fade" id="addTeacherPackageModal" tabindex="-1" aria-labelledby="addTeacherPackageModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
              <div class="modal-content">
                <div class="modal-header">
                  <h1 class="modal-title fs-5" id="showTeacherModalLabel">Add Teacher Package</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"  @click="onModalClose"></button>
                </div>
                <div class="modal-body">
                  <AddPackage :teacherId="selectedTeacherId" :teacherUserId="selectedTeacherUserId" :packageId="selectedPackageId"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </div>
    </template>
    
    <script>
    import axios from 'axios';
    import AddPackage from '@/components/Teacher/AddPackage.vue';
    
    export default {
      name: 'MoreTeacherDetails',
    
      data() {
        return {
          currentPage: 1,
          itemsPerPage: 2, // Adjust number of items per page here
    
          packages: [],
          startDate: '',
          endDate: '',
          start_date: '',
          end_date: '',
          teacher: null, // Replace with your actual data structure
          selectedTeacherId: null, // To store the selected teacher's ID
          selectedTeacherUserId: null, // To store the selected teacher's user ID
          selectedPackageId: null,
          account: null, // To store account details
          successMessage: null,
          errorMessage: null,
        };
      },
    
      components: {
        AddPackage,
      },
    
      props: {
        teacherId: {
          type: Number,
          required: true
        }
      },
    
      computed: {
        totalPages() {
          return Math.ceil(this.teacher.items.length / this.itemsPerPage);
        },
        paginatedItems() {
          const start = (this.currentPage - 1) * this.itemsPerPage;
          const end = start + this.itemsPerPage;
          return this.teacher.items.slice(start, end);
        },
    
        totalItemPrice() {
          if (this.teacher && this.teacher.items) {
            return this.teacher.items.reduce((sum, item) => {
              return sum + parseFloat(item.item_total_price || 0); // Ensure price is a number
            }, 0).toFixed(2); // Format as a number with 2 decimal places
          }
          return 0;
        },
    
        selectedPackage() {
          // Find the selected package by matching the id
          return this.packages.find(pkg => pkg.id === this.account.package_id);
        },
        
    
        // totalPackagePrice() {
        //   // Get the total item price
        //   const itemPrice = parseFloat(this.totalItemPrice) || 0;
    
        //   // Get the selected package price (if a package is selected)
        //   const packagePrice = this.selectedPackage ? parseFloat(this.selectedPackage.package_price) || 0 : 0;
        //   const packageDuration = this.selectedPackage && !isNaN(parseFloat(this.selectedPackage.duration)) ? parseFloat(this.selectedPackage.duration) : 0;
    
    
        //   // Calculate the total price
        //   return (itemPrice * packageDuration + packagePrice).toFixed(2); // Return sum with 2 decimal places
        // },


        totalPackagePrice() {
    const itemPrice = parseFloat(this.totalItemPrice) || 0;
    const selected = this.selectedPackage;

    if (!selected) return '0.00';

    const packagePrice = parseFloat(selected.package_price) || 0;
    const packageDuration = !isNaN(parseFloat(selected.duration)) ? parseFloat(selected.duration) : 0;

    let total = (itemPrice * packageDuration + packagePrice);

    // Apply discount based on package_id
    switch (this.account.package_id) {
      case 3:
        total *= 0.9;  // 10% discount
        break;
      case 4:
        total *= 0.8;  // 20% discount
        break;
      case 5:
        total *= 0.7;  // 30% discount
        break;
    }

    return total.toFixed(2);
  },
    
        totalStudents() {
          if (this.teacher && this.teacher.items) {
            return this.teacher.items.reduce((sum, item) => {
              return sum + parseFloat(item.student_level.level || 0); // Ensure price is a number
            }, 0).toFixed(0); // Format as a number with 2 decimal places
          }
          return 0;
        },
    
        totalSubjects() {
          if (this.teacher && this.teacher.items) {
            const subjects = new Set(this.teacher.items.map(item => item.subject.name));
            return subjects.size; // Return the count of unique subjects
          }
          return 0;
        },
    
      },
      
    
      methods: {
        goBack() {
          this.$router.push({ path: '/adminHome', query: { currentPage: 'teachers' } });
        },
        async fetchTeacherDetails() {
          try {
            const response = await axios.get(`/get-teacher-by-id/${this.teacherId}`);
            this.teacher = response.data;
          } catch (error) {
            console.error('Error fetching teacher details:', error);
          }
        },
        nextPage() {
          if (this.currentPage < this.totalPages) {
            this.currentPage++;
          }
        },
        prevPage() {
          if (this.currentPage > 1) {
            this.currentPage--;
          }
        },
    
        async fetchAccountDetails() {
          try {
            const response = await axios.get(`/get-account-by-teacher-id/${this.teacherId}`);
            this.account = response.data;
          } catch (error) {
            console.error('Error fetching account details:', error);
          }
        },
    
        onModalClose() {
          // Call the method to fetch teacher details when modal is closed
          this.fetchTeacherDetails();
          this.fetchAccountDetails();
        },
    
    
        openAddTeacherPackageModal(teacherId, teacherUserId, packageId) {
          this.selectedTeacherId = teacherId;
          this.selectedTeacherUserId = teacherUserId;
          this.selectedPackageId = packageId;
        },
    
        async deleteItem(itemId, index) {
          if (confirm('Are you sure you want to delete this item?')) {
            try {
              await axios.delete(`/delete-items/${itemId}`);
              this.teacher.items.splice(index, 1); // Remove the item from the local array after deletion
              this.fetchTeacherDetails();
              this.fetchAccountDetails();
            } catch (error) {
              console.error('Error deleting item:', error);
            }
          }
        },
    
        async fetchPackages() {
            try {
              const response = await axios.get('/get-all-packages');
              this.packages = response.data;
            } catch (error) {
              // this.errorMessage = 'Error fetching package.';
              console.error('Error fetching packages:', error);
            }
          },
    
        async submitForm() {
      const accountData = {
        userId: this.teacher.user.id, // Using userId to identify if record exists
        teacherId: this.teacher.id,
        startDate: this.start_date,
        endDate: this.end_date,
        packageId: this.account.package_id,
        totalStudents: this.totalStudents,
        totalSubjects: this.totalSubjects,
        totalPackagePrice: this.totalPackagePrice,
      };
    
      try {
        const response = await axios.post('/save-or-update-acc-data', accountData);
        // Display backend message
        if (response.data.message) {
          this.successMessage = response.data.message;
          this.errorMessage = null;
    
          this.fetchAccountDetails();
    
          // Remove the success message after 10 seconds
          setTimeout(() => {
            this.successMessage = ''; // Clear the success message
          }, 10000); // 10000 milliseconds = 10 seconds
        }
      } catch (error) {
        // Display backend error message
        if (error.response && error.response.data.message) {
          this.errorMessage = error.response.data.message;
        } else {
          this.errorMessage = 'An error occurred. Please try again.';
        }
        this.successMessage = null;
      }
    },
    
    formatDate(date) {
          const d = new Date(date);
          return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
        },
        calculateEndDate() {
          const durationInMonths = this.selectedPackage.duration; // Assuming duration is in months
          const startDate = new Date(this.start_date);
          const endDate = new Date(startDate);
          endDate.setMonth(startDate.getMonth() + durationInMonths); // Add duration in months
          this.end_date = this.formatDate(endDate); // Update end date
        },
      },
    
      watch: {
        selectedPackage(newPackage) {
          // Recalculate end date when selected package changes
          if (newPackage && newPackage.duration) {
            this.calculateEndDate();
          }
        },
        start_date() {
          // Recalculate end date whenever start date changes
          if (this.selectedPackage && this.selectedPackage.duration) {
            this.calculateEndDate();
          }
        },
      },
    
      mounted() {
        this.fetchTeacherDetails();
        this.fetchAccountDetails();
        this.fetchPackages();
    
        const modal = document.getElementById('addTeacherPackageModal');
        // Listen for Bootstrap's modal hide event to detect when the modal is closing
        modal.addEventListener('hide.bs.modal', this.onModalClose);
    
    
        // Set the start date to today
        // Set the start date to today
        this.start_date = this.formatDate(new Date());
    
        // Calculate the initial end date based on the package duration
        if (this.selectedPackage && this.selectedPackage.duration) {
          this.calculateEndDate();
        }
      }
    };
    </script>
    
      
      <style lang="scss" scoped>
      .mHeader{
        padding-bottom: 5%;
      }
      .card-title {
        font-size: 1.5rem;
        font-weight: 500;
      }
      
      .cardSet {
        display: flex;
      }
      
      .img-fluid {
        max-width: 150px;
        height: auto;
        border: 2px solid #ddd;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
      }
      
      .border {
        border-color: #f1f1f1;
      }
      
      .border {
        border-width: 1px;
      }
      </style>
      